import { useReducer } from 'react';
export function useForceUpdate() {
    return useReducer((v) => v + 1, 0)[1];
}
//# sourceMappingURL=index.js.map